<script lang="ts" setup>
import { UISkeleton } from '@gohighlevel/ghl-ui'
</script>
<template>
  <UISkeleton :sharp="false" class="flex h-12 w-full items-center" />
  <UISkeleton :sharp="false" class="h-56" />
</template>
